import { memo, useMemo } from 'react'
import fieldInputConnector from 'root/src/client/logic/form/connectors/fieldInputConnector'
import dynamic from 'next/dynamic'

const textFieldTypes = {
	universalForm: dynamic(() => import('root/src/client/web/form/TextFields/ManuallyStyledTextField')),
	default: dynamic(() => import('root/src/client/web/form/TextFields/MuiStyledTextField')),
}

export const InputField = memo((props) => {
	const TextFieldComponent = useMemo(() => {
		const textComponent = textFieldTypes[props.formType]

		if (!textComponent) {
			return textFieldTypes.default
		}

		return textComponent
	}, [props.formType])

	return <TextFieldComponent {...props} />
})

export default fieldInputConnector(InputField)
